<template>
  <header class="topbar">
    <b-navbar toggleable="sm" :type="`${navbarColor == 'white' ? 'light' : 'dark'}`" class="p-0" :variant="navbarColor">
      <b-navbar-nav>
        <b-nav-item @click="showMobileSidebar" class="d-block d-lg-none">
          <feather class="mr-0 feather-sm" type="menu" />
        </b-nav-item>
      </b-navbar-nav>
      <!-- Notificaciones -->
      <b-navbar-nav>
        <Notificaciones :animacionNotificacion="animacionNotificacion" :hayNotificaciones="hayNotificaciones"
          :numNoty="numNoty" :notify="notify" :fechaHoy="fechaHoy" :todasCargadas="todasCargadas"
          @ocultarPointNotificacion="ocultarPointNotificacion" @verAlertas="verAlertas"
          @cargarNotificacionesPorPartes="cargarNotificacionesPorPartes" />
      </b-navbar-nav>
      <!-- Menú usuario -->
      <b-navbar-nav class="ml-auto">
        <div style="display: flex;align-items: center; margin: 0 3px; cursor: pointer;" @click="goToAyuda()">
          <feather title="Ayuda" type="info" class="feather-sm mr-2 mb-n1" style="color: aliceblue;"></feather>
        </div>

        <b-nav-item-dropdown v-if="botonMasterVisible" id="botonMaster" right no-caret class="mailbox icons">
          <template #button-content>
            <span class="mr-1" style="font-weight: 700" @click="volverVistaMaster()">
              {{ $t("vistaMaster") }}
            </span>
            <feather type="eye-off" style="stroke-width: 2" class="feather-sm">
            </feather>
          </template>
        </b-nav-item-dropdown>
        <!-- Acciones menú usuario -->
        <MenuUsuario :username="username" :isEnglish="isEnglish" :sonido="sonido" :tema="tema" :visible="visible"
          :botonMasterVisible="botonMasterVisible" @volverVistaMaster="volverVistaMaster" @cambiarTema="changeTema"
          @cambiarIdioma="changeLanguage" @activaSonidoNotificacion="activaSonidoNotificacion" />
      </b-navbar-nav>
    </b-navbar>
  </header>
</template>

<script src="js/main.js"></script>
<script>
import { mapState } from "vuex";
import LogoDark from "../logo-dark/LogoDark";
import LogoLight from "../logo-light/LogoLight";

import AlertasDataService from "../../../services/AlertasDataService";
import DevicesDataService from "../../../services/DevicesDataService";
import UsersDataService from "../../../services/UsersDataService";
import Crypto from '../../../services/Crypto';

import { onMessage, getToken } from "firebase/messaging";

import {eventBus} from '@/main'

import MenuUsuario from './MenuUsuario.vue';
import Notificaciones from './Notificaciones.vue';

import { generalSweetAlert } from '../../../utils/Utils';

import {EventBusNotificaciones} from '../../../utils/event-bus';

export default {
  name: "vertical-header",
  components: {
    LogoDark,
    LogoLight,
    MenuUsuario,
    Notificaciones
  },
  data: () => ({
    sonido:false,
    tema: false,
    isEnglish: false,
    urlTono : require('../../../assets/Notificacion.mp3'),
    faviconNotificacion: '/faviconNotificacion.ico',
    faviconOrigen: '/favicon.ico',
    notify: [],
    listaAlertas: null,
    visible: false,
    username: sessionStorage.username,
    dispositivosTodos: null,
    fechaHoy: "",
    numNoty: 0,
    numeroAlertasServidor: 0,
    banNotify: false,
    animacionNotificacion: false,
    key: "",
    hayNotificaciones: false,
    usuarioLogueado: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
    tokenDeviceID: null,
    botonMasterVisible: false,

    pageScroll:0,
    sizeScroll:5,
    cargando: false,
    todasCargadas: false
  }),
  created() {
    const savedState = JSON.parse(localStorage.getItem("pointNotificacion"));
    this.botonMasterVisible = sessionStorage.getItem("botonMasterVisible") === "true";
    this.hayNotificaciones = savedState
  },
  async mounted() {
    this.key = sessionStorage.getItem('key');

    this.reloadNotificaciones()

    await this.obtenerTokenPushNotificaciones()
    await this.registrarTokenNotificacionesPush()

    this.obtenerDispositivos();
    this.$nextTick(() => {
      this.fechaHoy = new Date()
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, "/");
      //this.allAlertasPorMesActual()
      this.cargarNotificacionesPorPartes();
      this.obtenerTemaActual();
      this.obtenerEstatusAlarmaAudible();
      this.obtenerIdiomaActual();
    });
  },
  computed: {
    ...mapState(["navbarColor", "logoColor", "LayoutType"])
  },  
  methods: {

    /**
     * Método que obtiene el token de las notificaciones push y lo guarda en localStorage
     */
    /*async obtenerTokenPushNotificaciones() {
      try {
        const currentToken = await getToken(this.$messaging,
          { vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY });
        if (currentToken) {
          localStorage.setItem('tokenPush', currentToken)
        }
      } catch (error) {
        console.error("obtenerTokenPushNotificaciones::", error);
      }
    },*/

    async obtenerTokenPushNotificaciones() {
      try {
        if ('serviceWorker' in navigator) {
          const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

          const currentToken = await getToken(this.$messaging, {
            vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY,
            serviceWorkerRegistration: registration // <--- Línea clave
          });

          if (currentToken) {
            localStorage.setItem('tokenPush', currentToken);
          }
        }
      } catch (error) {
        console.error("obtenerTokenPushNotificaciones::", error);
      }
    },

    /**
     * Método que registra el token de notificaciones push en la base de datos
     */
    async registrarTokenNotificacionesPush(){
      try{
        const data = {
          token: localStorage.getItem('tokenPush'),
          sistemaOperativo: "web"
        };
        await UsersDataService.createTokenPush(data, this.key);
      }catch(error){
        console.error("registrarTokenNotificacionesPush::", error);
      }
    },

    /**
     * Método que está en escucha de nuevas notificaciones y refresca el listado de alertas
     */
    reloadNotificaciones(){
      onMessage(this.$messaging, (payload) => {
        /*const titulo = payload.notification?.title || payload.data?.title;
        const cuerpo = payload.notification?.body || payload.data?.body;
        if (titulo) {
          generalSweetAlert(cuerpo ? `${titulo}: ${cuerpo}` : titulo, "info");
        }*/
        this.manejarNotificacionNueva();
      });

      // Con la pestaña en segundo plano FCM no dispara onMessage: lo avisa el service worker
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.addEventListener("message", (event) => {
          if (event.data?.type === "FCM_BACKGROUND_MESSAGE") {
            this.manejarNotificacionNueva();
          }
        });
      }

      // Al volver a la pestaña se refrescan las alertas por si se perdió alguna
      document.addEventListener("visibilitychange", async () => {
        if (document.visibilityState === "visible") {
          const nuevas = await this.cargarNotificacionesRecientes();
          if (nuevas > 0) {
            this.setTrueHayNotificaciones();
            this.mostrarAnimacionNotificacion();
          }
          eventBus.$emit("alertas", "recargarAlertas");
        }
      });
    },

    /**
     * Método que refresca el listado de alertas y avisa al usuario de una notificación nueva
     */
    manejarNotificacionNueva(){
      this.notificacionAudible()
      this.cargarNotificacionesRecientes();
      this.mostrarAnimacionNotificacion()
      this.setTrueHayNotificaciones()
      eventBus.$emit("alertas", "recargarAlertas")
    },

    ocultarPointNotificacion(){
      this.hayNotificaciones = false;
      localStorage.setItem("pointNotificacion", "false");
    },

    setTrueHayNotificaciones(){
      this.hayNotificaciones = true;
      localStorage.setItem("pointNotificacion", "true");
    },

    showMobileSidebar() {
      this.$store.commit("SET_SIDEBAR_DRAWER", true);
    },

    setMiniSidebar() {
      if (this.LayoutType == "full-sidebar") {
        this.$store.dispatch("setLayoutType", "mini-sidebar");
      } else if (this.LayoutType == "mini-sidebar") {
        this.$store.dispatch("setLayoutType", "full-sidebar");
      }
    },

    volverVistaMaster(){
      this.$swal({
        text: this.$t('vistaMasterQ'),
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "gray",
        confirmButtonText: this.$t('Gral.aceptar'),
        cancelButtonText: this.$t('Gral.cancelar'),
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.botonMasterVisible = false;
          sessionStorage.setItem("botonMasterVisible", this.botonMasterVisible);
          
          sessionStorage.setItem('usuarioFiltro', "");
          sessionStorage.setItem("nombreUsuario", "null");
          
          this.$router.push({
            path: "/monitoreo",
          });

          location.reload();
          generalSweetAlert("Regresar a vista master", 'success');

        }
      });
    },

    async allAlertasPorMesActual(){
      try {
        const response = await AlertasDataService.getAllPorMes()
        this.listaAlertas = await  Crypto.desencriptar(response.data, this.key);
        //usuario Master oculta/muestra boton "Regresar a vista master"
        if (sessionStorage.idRol == process.env.VUE_APP_ID_MASTER) { 
          const usuarioFiltro = sessionStorage.getItem("usuarioFiltro");
          if (usuarioFiltro && usuarioFiltro !== "") {
            this.botonMasterVisible = window.innerWidth >= 992;
          } else {
            this.botonMasterVisible = false;
          }
          sessionStorage.setItem("botonMasterVisible", this.botonMasterVisible);
        }

        if(this.listaAlertas.length > 0){
          this.notify = this.listaAlertas;
          this.numNoty = this.listaAlertas.length;
        }else{
          this.numNoty = 0;
        }
       
      } catch (error) {
      }
    },

    mostrarAnimacionNotificacion() {
      this.animacionNotificacion = true;
      setTimeout(() => {
        this.animacionNotificacion = false; 
      }, 5000);
    },

    /**
     * Meotodo que dispara la alarma sonora
     * @param data: Estatus del valor alarmaAudible el cual viene de las configuraciones del usuario actual
     */
    notificacionAudible(){
      if(this.sonido === true){ 
        let tonoNotificacion = new Audio(this.urlTono)
        tonoNotificacion.play();
      }
    },

    /**
     * Método que cambia el favicionNotificacion al favicon original
     */
    CambiafaviconOrigen(){

      //Obtenemos el elemento del favicon
      let favicon =  document.getElementById('favicon');
      
      //Obtenemos el atributo hrfe
      let nombreFabicon = favicon.getAttribute("href");
      //Reemplazamos la diagonal
      nombreFabicon = nombreFabicon.replace('/','');

      if( nombreFabicon != 'favicon.ico' ){
        favicon.setAttribute("href", this.faviconOrigen);
      }

    },
 
    verAlertas() {
      var ruta = this.$router.currentRoute;
      
      if(ruta.path === "/monitoreo"){
        EventBusNotificaciones.$emit('toggle-sidebar', 'B');
        
      }else{
        sessionStorage.setItem("alerta", "true");
        this.$router.push({
          path: "/monitoreo",
        });
      }
      
    },

    async obtenerDispositivos() {
      DevicesDataService.getAll()
        .then(async(response) => {
          this.dispositivosTodos = await Crypto.desencriptar(response.data, this.key);
          if (sessionStorage.idRol === process.env.VUE_APP_ID_MASTER) {
            if (sessionStorage.getItem("usuarioFiltro") != "") {
              var user = JSON.parse(sessionStorage.getItem("usuarioFiltro"));
              if (user.rol.id == process.env.VUE_APP_ID_ADMINISTRADOR) {
                var dispo = [];
                this.dispositivosTodos.forEach((value, index) => {
                  if (value.area != null) {
                    if (value.area.id == user.area.id) {
                      dispo.push(value);
                    }
                  }
                });
                this.dispositivosTodos = dispo;
              } else {
                this.usuarioSesion = user;
                var dispo = [];
                this.dispositivosTodos.forEach((value, index) => {
                  if (value.usuarios != null) {
                    value.usuarios.forEach((val, i) => {
                      if (val.id == user.id) {
                        dispo.push(value);
                      }
                    });
                  }
                });
                this.dispositivosTodos = dispo;
              }
            }
          }
        });
    },

    activaSonidoNotificacion(){
      if (this.sonido === false) {
        this.sonido = true;
      } else {
        this.sonido = false;
      }
    },
    
    changeTema(){
      if (this.tema  === false) {
        this.tema = true;
        this.$store.commit("SET_THEME", 'dark');
      } else {
        this.tema = false;
        this.$store.commit("SET_THEME", 'light');
      }
    },
    
    changeLanguage(){
      if (this.isEnglish  === false) {
        this.isEnglish = true;
        this.$i18n.locale = 'en'
      } else {
        this.isEnglish = false;
        this.$i18n.locale = 'es'
      }

      generalSweetAlert(this.$t('popIdioma'), 'success');
    },

    hoverHabilitado(hab) {
      if (hab) return this.$t('Deshabilitar');
      else return this.$t('Habilitar');
    },

    /***
     * Metodo que permite obtener el estatus de la alarma audible
     */
    async obtenerEstatusAlarmaAudible(){
      UsersDataService.getAlarmaAudible()
        .then(async(response)=>{
          this.sonido = await Crypto.desencriptar(response.data, this.key);
        });
    },

    /**
     * Método que permite obtener el estatus de tema actual
     */
    async obtenerTemaActual() {
      try {
      const response = await UsersDataService.getTemaOscuro();
      this.tema = await Crypto.desencriptar(response.data, this.key);
      if (this.tema === false) {
        this.$store.commit("SET_THEME", 'light');
      } else {
        this.$store.commit("SET_THEME", 'dark');
      }
      } catch (error) {
        generalSweetAlert(this.$t('Gral.msgErrorDesconocido'), 'error');
      }
    },

    /**
     * Método que permite obtener el estatus del idioma actual del sistema
     */
    async obtenerIdiomaActual() {
      try {
      const response = await UsersDataService.getIdiomaActual();
      this.isEnglish = await Crypto.desencriptar(response.data, this.key);
      if (this.isEnglish === false) {
        this.$i18n.locale = 'es';
      } else {
        this.$i18n.locale = 'en';
      }
      } catch (error) {
        generalSweetAlert(this.$t('Gral.msgErrorDesconocido'), 'error');
      }
    },

    verNotificaciones() {
      if(this.banNotify === true){
        this.quitarNotificacion();
      }
      this.banNotify = false;  
      // Mandamos a llamar la funcion para cambiar el favicon original
      this.CambiafaviconOrigen();
    },

    quitarNotificacion(){
      UsersDataService.notificar(this.key)
        .then((response)=>{
          if(response !== null)
            this.banNotify = false;
        });
    },

    async cargarNotificacionesPorPartes(){
      if (this.cargando || this.todasCargadas) return;
      this.cargando = true;
      try {
        let data = {
            page: this.pageScroll, // backend espera base 0
            size: this.sizeScroll,
          };
        const response = await AlertasDataService.getPorMesNotificacionesPorPartes(data,this.key)
        this.listaAlertas = await Crypto.desencriptar(response.data, this.key);
        
        //usuario Master oculta/muestra boton "Regresar a vista master"
        if (sessionStorage.idRol == process.env.VUE_APP_ID_MASTER) { 
          const usuarioFiltro = sessionStorage.getItem("usuarioFiltro");
          if (usuarioFiltro && usuarioFiltro !== "") {
            this.botonMasterVisible = window.innerWidth >= 992;
          } else {
            this.botonMasterVisible = false;
          }
          sessionStorage.setItem("botonMasterVisible", this.botonMasterVisible);
        }

        if(this.listaAlertas.length > 0){
          //this.notify = this.listaAlertas;
          this.notify = [...this.notify, ...this.listaAlertas];// se concatena el lista de alertas
          
          this.numNoty = this.listaAlertas.length;
          this.pageScroll ++;
          if(this.listaAlertas.length < this.sizeScroll){
            this.todasCargadas = true;
          }
        }else{
          if(this.notify.length == 0){
            this.numNoty = 0;
            this.todasCargadas = true;
          }
          
        }
       
      } catch (error) {
        console.error("Error en la peticion cargarNotificacionesPorPartes: ",error)
      } finally {
      }
      this.cargando = false;
      
    },

    async cargarNotificacionesRecientes() {
      try {
        let data = {
            page: 0, // backend espera base 0
            size: this.sizeScroll,
          };
        const response = await AlertasDataService.getPorMesNotificacionesPorPartes(data, this.key);
        const recientes = await Crypto.desencriptar(response.data, this.key);

        // Filtrar las nuevas que aún no están en el arreglo actual
        const nuevas = recientes.filter(nueva => {
          return !this.notify.some(existente => existente.id === nueva.id); // usa campo ID único
        });

        if (nuevas.length > 0) {
          // Insertar nuevas al inicio del arreglo
          this.notify = [...nuevas, ...this.notify];
          this.numNoty = this.notify.length;
        }
        return nuevas.length;
      } catch (error) {
        console.error("Error al cargar notificaciones recientes:", error);
        return 0;
      }
    },

    goToAyuda(){
      this.$router.replace({ name: 'Ayuda' });
    }

  }//End methods
};
</script>
<style>
.icon-alert {
  width: 40px;
  height: 50px;
}

.alertas {
  font-size: 12px;
}

#notifyBell {
  margin-left: 16px;
}

@media (max-width: 680px) {
  #botonMaster {
    display: none;
  }
}

@media (max-width: 991.98px) and (max-height: 950px) {
  #notifyBell {
    margin-left: 0px;
  }
}

@media (min-width: 3150px) {

  /* 1. Aumentar la altura de la Topbar */
  .topbar {
    height: 100px !important;
    /* Altura imponente para pantallas grandes */
    align-items: center;
  }

  .topbar .navbar {
    height: 100% !important;
    padding: 0 2rem !important;
    /* Espaciado lateral */
  }

  /* 2. Escalar Iconos de Feather (Campana, Menu, Ojo) */
  .topbar .feather,
  .topbar .feather-sm {
    width: 3rem !important;
    height: 3rem !important;
    stroke-width: 2.5px;
    /* Líneas más gruesas para 4K */
  }

  /* 3. Escalar Textos (Usuario, Vista Master, Notificaciones) */
  .topbar .nav-link,
  .topbar .nav-item span,
  #botonMaster span {
    font-size: 1.8rem !important;
    line-height: 1 !important;
    display: flex;
    align-items: center;
  }

  /* 4. Ajustar el Botón Master y márgenes */
  #botonMaster {
    margin-right: 2rem !important;
  }

  #notifyBell {
    margin-left: 30px !important;
    /* Más separación en Ultrawide */
  }

  /* 5. Ajustar los Menús Desplegables (Dropdowns) */
  /* Esto afecta al menú que sale al hacer clic en el usuario o notificaciones */
  .topbar .dropdown-menu {
    min-width: 28rem !important;
    min-height: 20rem;
    font-size: 1.5rem !important;
    padding: 1.5rem !important;
    border-radius: 1rem !important;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2) !important;
  }

  .topbar .dropdown-item {
    padding: 1rem 1.5rem !important;
    margin-bottom: 0.5rem !important;
  }
}
</style>
